import { httpRequest } from "../../http";
import type { Discrepancy, DiscrepancyStatus } from "@models/Discrepancy.model";

export class CommandListDiscrepancies {
  async run(filters: { status?: DiscrepancyStatus; populationSegmentId?: number }): Promise<Discrepancy[]> {
    const params = new URLSearchParams();
    if (filters.status) params.set("status", filters.status);
    if (filters.populationSegmentId) params.set("population_segment", String(filters.populationSegmentId));
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/ingest/discrepancies/?${params.toString()}`;
    return httpRequest<Discrepancy[]>(url, { method: "GET" });
  }
}
